module.exports = __webpack_public_path__ + "img/yl@3x.1e6e77e1.png";